import styled, { css } from 'styled-components';
import { Tenant, TENANT_NAME } from '../../config/tenants';

const isTuw = TENANT_NAME === Tenant.TUW;

export const ImageUploadWrapper = styled.div`
  width: 100%;
  margin: 1rem 0;

  ${isTuw &&
  css`
    [data-testid='dropzone'] button,
    [data-testid='dropzone'] button * {
      color: ${({ theme }) => theme.palette.brand.color} !important;
      -webkit-text-fill-color: ${({ theme }) => theme.palette.brand.color};
      opacity: 1 !important;
    }

    [data-testid='dropzone'] button {
      background-color: transparent !important;
      background-image: none !important;
      -webkit-background-clip: border-box !important;
      -moz-background-clip: border-box !important;
      border: 2px solid ${({ theme }) => theme.palette.brand.color} !important;
      padding-inline: 12px !important;
      overflow: hidden !important;
    }

    [data-testid='dropzone'] button::before,
    [data-testid='dropzone'] button::after {
      display: none !important;
      background: none !important;
    }
  `}
`;
